import { render, staticRenderFns } from "./weightTemplates.vue?vue&type=template&id=7bdf336e&scoped=true"
import script from "./weightTemplates.vue?vue&type=script&lang=js"
export * from "./weightTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf336e",
  null
  
)

export default component.exports